<div class="page-wrapper body-init">
    <img src="assets/images/escudo-blanco.png" class="escudo-bg" alt="Escudo El Salvador" />
    <div class="authentication-box">
        <div class="container">
            <div class="row">
                <div class="col-md-3 p-0 card-left">
                    
                </div>
                <div class="col-md-7 p-0 card-right">
                    <div class="card tab2-card card-login">
                        <div class="card-body text-center">
                            <div class="logo-wrapper">
                                <a [routerLink]="'/dashboard/default'">
                                    <img class="blur-up lazyloaded img-logo" [src]="logoUrl"
                                        (error)="onLogoError($event)" alt="Logo" />
                                </a>
                            </div>

                           

                            <p class="text-center" style="color: #091035; font-weight: 500;
                                font-size: 22px;">
                                Firma 365.
                            </p>

                            <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
                                <li [ngbNavItem]="1">
                                    <a ngbNavLink>Login</a>
                                    <ng-template ngbNavContent>
                                        <div class="tab-pane fade active show" id="account" role="tabpanel"
                                            aria-labelledby="account-tab">
                                            <form [formGroup]="loginForm" class="form-horizontal auth-form" novalidate>
                                                <div class="form-group">
                                                    <input required="" formControlName="userName" type="email"
                                                        class="form-control" placeholder="Username o email"
                                                        id="exampleInputEmail1">

                                                    <span class="text-danger"
                                                        *ngIf="(loginForm.get('userName')?.touched  || formLoginIsSubmited ) && loginForm.get('userName')?.errors?.['required']">
                                                        El usuario es requerido
                                                    </span>
                                                </div>
                                                <div class="form-group">
                                                    <div class="input-group">
                                                        <input required="" formControlName="password"
                                                            [type]="showPassword ? 'text' : 'password'"
                                                            class="form-control" placeholder="Password">
                                                        <button type="button" class="btn btn-outline-secondary"
                                                            (click)="togglePasswordVisibility()">
                                                            
                                                            <i
                                                                class="fa-solid {{ showPassword ? 'fa-eye-slash' : 'fa-eye' }} "></i>
                                                        </button>
                                                    </div>

                                                    <span class="text-danger"
                                                        *ngIf="(loginForm.get('password')?.touched  || formLoginIsSubmited ) && loginForm.get('password')?.errors?.['required']">
                                                        La contraseña es requerida
                                                    </span>
                                                </div>
                                                <div class="form-terms">
                                                    <div class="custom-control 
                                                        custom-checkbox 
                                                        d-flex 
                                                        align-items-center 
                                                        flex-wrap">
                                                        <a href="javascript:void(0)"
                                                            class="btn btn-default forgot-pass ms-auto"
                                                            style="text-transform: none !important;"
                                                            (click)="navigateRestorePassword()">¿Olvidaste tu
                                                            contraseña?</a>
                                                    </div>
                                                </div>
                                                <div class="form-button">
                                                    <button class="btn btn-primary" type="submit" (click)="onSubmit()" [disabled]="this.formLoginIsSubmited || loginForm.invalid">
                                                        Ingresar
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </ng-template>
                                </li>
                            </ul>
                            <div [ngbNavOutlet]="nav" class="mt-2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>